/**
 * Assistance Event API Endpoints
 *
 * Handles assistance events (Assistance_Case__c != null, Claim_Case__c = null)
 * for creating claims from existing assistance events.
 */

import axiosInstance from '../axiosInstance';
import type { ClaimDataResponse } from '../../../types/api';

/**
 * Get assistance events without claim for given contracts.
 *
 * GET /api/v1/claims/assistance-events?contractNumbers=CT-001&contractNumbers=CT-002
 *
 * @param contractNumbers - List of contract numbers
 * @returns Promise<ClaimDataResponse[]>
 */
export async function getAssistanceEventsWithoutClaim(
  contractNumbers: string[]
): Promise<ClaimDataResponse[]> {
  const response = await axiosInstance.get<any>(
    '/api/v1/claims/assistance-events',
    {
      params: { contractNumbers },
      paramsSerializer: {
        indexes: null, // Use "contractNumbers=CT-001&contractNumbers=CT-002" format
      },
    }
  );

  return response.data?.payload || [];
}

